import React, { useState } from 'react';
import { FaFileCsv, FaSpinner } from 'react-icons/fa';

// Generic CSV download button. Caller provides headers + rows + filename.
// Generates the CSV client-side; no backend call. Safe for ≤ 10k rows
// before browser blob memory becomes a concern.
const escapeCell = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const CsvExportButton = ({
    headers,
    rows,
    filename,
    label = 'Export CSV',
    summary = [],
    className = 'px-4 py-2 bg-[#83a598] text-[#1d2021] rounded-lg hover:bg-[#458588] font-medium inline-flex items-center gap-2 text-sm',
    disabled = false,
}) => {
    const [busy, setBusy] = useState(false);

    const download = () => {
        setBusy(true);
        try {
            const headerLine = headers.map(escapeCell).join(',');
            const dataLines = rows.map(r => r.map(escapeCell).join(','));
            const summaryLines = summary.map(line => `# ${line}`);
            const csv = [headerLine, ...dataLines, '', ...summaryLines].join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || `export-${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            alert(`CSV export failed: ${e.message}`);
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            onClick={download}
            disabled={disabled || busy || rows.length === 0}
            className={`${className} ${(disabled || busy || rows.length === 0) ? 'opacity-50 cursor-not-allowed' : ''}`}
            title={rows.length === 0 ? 'No rows to export' : ''}
        >
            {busy ? <FaSpinner className="animate-spin" /> : <FaFileCsv />}
            {label}
        </button>
    );
};

export default CsvExportButton;
